import React from 'react';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { formatTime, useIsMobileDimensions } from '../../shared/utils';
import { PuzzleNames, PuzzleNamesForUI } from '../../../../utils/types';
import StatsDialog from '../../shared/StatsDialog';
import AssistToolbar from './AssistToolbar';
import Instructions from './Instructions';
import { ArithmeglyphsStore } from '../ArithmeglyphsStore';
import { saveArithmeglyphs } from '../arithmeglyphsUtils';
import MobileInstructions from './MobileInstructions';
import '../../shared/PuzzleTopBar/PuzzleTopBar.less';

const ArithmeglyphsTopBar = () => {
  const { completed, time, isPaused } = ArithmeglyphsStore.useState();

  const useMobileStyles = isMobile || useIsMobileDimensions();
  const navigate = useNavigate();

  const pauseButtonClass = completed ? 'hidden' : '';

  return (
    <div className={`puzzleTopBar arithmeglyphsTopBar ${useMobileStyles ? 'mobile' : ''}`}>
      <div className="topBarLeftSection">
        <IconButton disableRipple title="Back" onClick={() => {
          navigate('/');
          window.scrollTo(0, 0);
          saveArithmeglyphs();
        }}>
          <KeyboardBackspaceIcon/>
        </IconButton>
        <div className="navigationLabel">{PuzzleNamesForUI[PuzzleNames.Arithmeglyphs]}</div>
      </div>

      <div className="topBarMiddleSection">
        <div className="timer">{formatTime(time)}</div>
        <IconButton className={pauseButtonClass} title="Pause" onClick={() => {
          ArithmeglyphsStore.update(s => {
            if (!s.isPaused) {
              saveArithmeglyphs();
            }
            s.isPaused = !s.isPaused;
          });
          window.scrollTo(0, 0);
        }}>
          {isPaused ? <PlayArrowIcon/> : <PauseIcon/>}
        </IconButton>
      </div>

      <div className="topBarRightSection">
        {isMobile ? <MobileInstructions/> : <Instructions/>}
        <StatsDialog puzzleName={PuzzleNames.Arithmeglyphs} store={ArithmeglyphsStore as any} />

        <AssistToolbar/>

        <IconButton disableRipple title="How to Play" onClick={() => {
          ArithmeglyphsStore.update(s => {
            s.instructionsAreOpen = true;
            s.isSoftPaused = true;
          });
        }}>
          <HelpOutlineIcon/>
        </IconButton>

        <IconButton disableRipple title="Stats" onClick={() => {
          ArithmeglyphsStore.update(s => {
            s.statsDialogIsOpen = true;
            s.isSoftPaused = true;
          });
        }}>
          <EqualizerIcon/>
        </IconButton>
      </div>
    </div>
  );
};

export default ArithmeglyphsTopBar;